export enum Occupation {
	employed = "有職（パート・アルバイト含む）",
	notEmployed = "無職",
	student = "学生",
}
